﻿import {IDisposableLike} from "./IDisposableLike";

export class RessourceSlot<T extends IDisposableLike> {
    #value: T | undefined
    
    constructor(initial?: T) {
        this.#value = initial;
    }
    
    public get Value(): T | undefined {
        return this.#value;
    }
    
    public set Value(next: T | undefined) {
        if (this.#value && this.#value !== next)
            try { this.#value.Dispose(); } catch { }
        
        this.#value = next;
    }
    
    public Clear = (): void => { this.Value = undefined; }
    
    
    public Reset = (factory: () => T): T => {
        const inst = factory();
        this.Value = inst;
        return inst;
    }

    /** Exécute une action si la ressource est présente (facilite l’usage sécurisé) */
    public With<R>(fn: (resource: T) => R): R | undefined {
        const r = this.Value;
        return r ? fn(r) : undefined;
    }
    
    public Dispose = () => this.Clear();
}